import { render, staticRenderFns } from "./CascaderCopy.vue?vue&type=template&id=c52f985a&scoped=true&"
import script from "./CascaderCopy.vue?vue&type=script&lang=js&"
export * from "./CascaderCopy.vue?vue&type=script&lang=js&"
import style0 from "./CascaderCopy.vue?vue&type=style&index=0&id=c52f985a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52f985a",
  null
  
)

export default component.exports